import React, { useState } from "react";
import { Banner, Input, Section, Spinner, Table } from "@cinesys/ui/components";
import Fuse from "fuse.js";
import { Search } from "react-feather";
import { styled } from "styled-components";
import { useOrganizationQuery } from "../../hooks/useOrganizationQuery";

const Wrapper = styled.div`
  width: 50%;
  margin: auto;
  padding-top: 30px;
  padding-bottom: 50px;
  max-width: 500px;
`;

const Row = styled.div`
  font-size: 16px;
  display: flex;
  align-items: center;
`;

const SearchWrap = styled.div`
  padding: 10px;
`;

const OrganizationList = () => {
  const { data, isLoading, isError } = useOrganizationQuery();
  const [search, setSearch] = useState("");

  let rows = data ?? [];
  if (search) {
    const fuse = new Fuse(rows, {
      keys: [
        {
          name: "label",
          getFn: (o) => (typeof o.label === "string" ? o.label : ""),
        },
        { name: "value", getFn: (o) => o.value ?? "" },
      ],
      ignoreLocation: true,
      threshold: 0.3,
      shouldSort: false,
    });
    rows = fuse.search(search).map((r) => r.item);
  }

  return (
    <Wrapper>
      <Section title="Choose an Organization">
        <SearchWrap>
          <Input
            value={search}
            onChange={setSearch}
            placeholder="Search"
            icon={Search}
            clearable
          />
        </SearchWrap>
        {isLoading ? (
          <Spinner />
        ) : isError ? (
          <Banner error="Error loading organizations" />
        ) : (
          <Table
            style={
              {
                "--tableHeaderBg": "transparent",
                "--tableHeaderBorderBottom": "1px solid var(--dark300)",
                "--tableHeaderShadow": "none",
              } as React.CSSProperties
            }
            rows={rows.map(({ label, value }) => ({
              element: () => <Row>{label}</Row>,
              id: value ?? "",
              link: `../dashboard/${value}/plugin`,
            }))}
            autoHeight={{}}
          />
        )}
      </Section>
    </Wrapper>
  );
};

export default OrganizationList;
